// extracted by mini-css-extract-plugin
export default {"root":"bannerAdmin_root__9Xoqv"};